// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"76":"3c67a094","160":"c43ab722","614":"5ef018e7"}[chunkId] + ".chunk.css";
};